import { render, staticRenderFns } from "./friendly_matches.vue?vue&type=template&id=e7f989d2&"
import script from "./friendly_matches.vue?vue&type=script&lang=js&"
export * from "./friendly_matches.vue?vue&type=script&lang=js&"
import style0 from "./friendly_matches.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports